<template>
  <div>
    <v-toolbar color="page-toolbar">
      <v-toolbar-title class="text-body-large"> Liste des utilisateurs <small>(Administration)</small> </v-toolbar-title>
    </v-toolbar>

    <v-card>
      <v-btn class="fab-absolute-top-right" color="success" @click="$router.push({ name: 'admin-user-add' })" icon size="large">
        <v-icon> mdi-plus </v-icon>
      </v-btn>
      <v-card-title class="d-flex flex-wrap align-center ga-2">
        Utilisateurs
        <v-spacer></v-spacer>
        <v-select
          v-model="membershipFilter"
          :items="membershipFilterOptions"
          item-title="text"
          item-value="value"
          label="Filtrer abonnement"
          hide-details
          density="compact"
          class="mr-4"
          style="max-width: 260px"
        ></v-select>
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table :headers="headers" :items="filteredUsers" :search="search" :loading="loadingUsers">
        <template v-slot:loading>
          <v-skeleton-loader type="table-row@8"></v-skeleton-loader>
        </template>
        <template v-slot:[`item.membershipLabel`]="{ item }">
          <v-chip size="x-small" :color="item.membershipActive ? 'success' : 'grey'">
            {{ item.membershipLabel }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon size="small" class="mr-2" @click="editUser(item)"> mdi-pencil </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import { /*auth,*/ functions } from "@/firebase";

  export default {
    data() {
      return {
        search: "",
        headers: [
          {
            title: "Nom",
            align: "start",
            key: "displayName",
          },
          { title: "Email", key: "email" },
          { title: "Abonnement", key: "membershipLabel" },
          { title: "Créé le", key: "metadata.creationTime" },
          { title: "Dernière connexion", key: "metadata.lastSignInTime" },
          { title: "ID", key: "uid" },
          { title: "Action", key: "actions" },
        ],
        users: [],
        loadingUsers: false,
        membershipFilter: "all",
        membershipFilterOptions: [
          { text: "Tous", value: "all" },
          { text: "Membres actifs", value: "active" },
          { text: "Membres (tous)", value: "member" },
          { text: "Admins", value: "admin" },
          { text: "Sans abonnement actif", value: "inactive" },
        ],
      };
    },
    computed: {
      filteredUsers() {
        if (this.membershipFilter === "all") {
          return this.users;
        }

        if (this.membershipFilter === "active") {
          return this.users.filter((user) => Boolean(user.membershipActive));
        }

        if (this.membershipFilter === "member") {
          return this.users.filter((user) => user.membershipAccess === "member");
        }

        if (this.membershipFilter === "admin") {
          return this.users.filter((user) => user.membershipAccess === "admin");
        }

        if (this.membershipFilter === "inactive") {
          return this.users.filter((user) => !user.membershipActive);
        }

        return this.users;
      },
    },
    async created() {
      await this.getAllUsers();
    },
    methods: {
      getMembershipLabel(user) {
        if (user.membershipAccess === "admin") {
          return "Admin";
        }

        if (user.membershipAccess === "member") {
          return user.membershipActive ? "Membre actif" : "Membre expiré";
        }

        return "Aucun";
      },
      async getAllUsers() {
        this.loadingUsers = true;
        var getAllUsersFromFirebase = functions.httpsCallable("getAllUsersFromFirebase");
        try {
          const users = await getAllUsersFromFirebase()
            .then((result) => {
              return result.data;
            })
            .catch((error) => {
              console.log(error);
              return [];
            });
          this.users = Array.isArray(users)
            ? users.map((user) => ({
                ...user,
                membershipLabel: this.getMembershipLabel(user),
              }))
            : [];
        } finally {
          this.loadingUsers = false;
        }
      },
      editUser(user) {
        var slug = user.uid;
        this.$router.push({ name: "admin-user-edit", params: { slug: slug, user: user } });
      },
    },
  };
</script>

<style></style>
